module.exports = __webpack_public_path__ + "static/media/plus-circle.0180b332.svg";